import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { propId } from '../../../../../../../helpers/custom-prop-types';
import ArrowNextIcon from '../../../../../../Icon/Svg/ArrowNextIcon';
const RfpOneNextLink = (props) => {
    const { id, viewRequestId } = props;
    return (_jsx("div", Object.assign({ className: 'next_link' }, { children: _jsxs(DynamicLink, Object.assign({ className: clsx('next_value', !viewRequestId && 'is-disabled'), noLinkElement: !viewRequestId ? 'span' : undefined, to: `/project/client/${id}/offer/${viewRequestId}` }, { children: [_jsx(ArrowNextIcon, { className: 'next_icon' }), _jsx("span", Object.assign({ className: 'next_text' }, { children: "\u6B21\u306E\u63D0\u6848" }))] })) })));
};
RfpOneNextLink.propTypes = {
    id: propId().isRequired,
    viewRequestId: propId(),
};
RfpOneNextLink.defaultProps = {
    viewRequestId: null,
};
export default RfpOneNextLink;
